import multiStemTreeImage from "@/assets/multi-stem-tree-image.jpg";

import { getText, interpolate } from "shared/lib";
import {
  TreePropertyType,
  type DBHTreePropertyDescriptor,
  type TreeDescriptor,
} from "@/components/treeModule/lib";

import { Separator } from "shared/components";

export interface MultiStemDiameterContentProps {
  treeDescriptor: TreeDescriptor | undefined | null;
}

export function MultiStemDiameterContent({
  treeDescriptor,
}: MultiStemDiameterContentProps) {
  const dbh = treeDescriptor?.properties.get(TreePropertyType.dbh) as
    | DBHTreePropertyDescriptor
    | undefined;

  return (
    <div className="text-bodymd text-textPrimary flex w-full flex-wrap gap-4">
      <div className="flex flex-[1_1_300px] flex-col gap-4">
        <p>
          {getText(
            "A tree's measurements help determine if it is protected by the planning scheme or Council's local laws.",
          )}
        </p>

        <Separator orientation="horizontal" />

        <p>
          {interpolate(
            "To measure a multi stem tree, measure the longest face of each trunk at point 'A', 'B' and 'C' to get each trunk's diameter. Then, add the measurements together. Points 'A', 'B' and 'C' are {{distanceAboveGround}} above ground level, measured along the trunks' length from the closest point above ground level.",
            {
              distanceAboveGround: dbh?.distanceAboveGround,
            },
          )}
        </p>
      </div>

      <div
        className="h-[300px] max-h-[300px] w-full max-w-[290px] flex-[1_1_200px] rounded"
        style={{
          background: `url(${multiStemTreeImage}) lightgray no-repeat`,
          backgroundPosition: "bottom",
          backgroundSize: "100% auto",
        }}
      />
    </div>
  );
}
